var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-7.5-3V-5.5H-10a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.5V-9A.5.5,0,0,1-7-9.5a.5.5,0,0,1,.5.5v2.5H-4a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H-6.5V-3a.5.5,0,0,1-.5.5A.5.5,0,0,1-7.5-3ZM-14-11a2,2,0,0,1,2-2H-2a2,2,0,0,1,2,2V-1A2,2,0,0,1-2,1H-12a2,2,0,0,1-2-2Zm1,0V-1a1,1,0,0,0,1,1H-2A1,1,0,0,0-1-1V-11a1,1,0,0,0-1-1H-12A1,1,0,0,0-13-11Z",
    transform: "translate(14 13)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.7a7cf0aa5a17189d3ad3426180880c1a.svg";
export { ForwardRef as ReactComponent };